const CONFIG = {
  //API_BASE_URL: 'http://localhost:8000',
  API_BASE_URL: 'https://uficon-loop-backend-777160588326.asia-southeast1.run.app',
};

export default CONFIG;
